<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="v_tableData"
      :columns="tableColumns"
      :height="333"
      border
      :tree-config="{
        children: 'children',
        expandAll: true,
      }"
      row-id="shipmentPayStatementCode"
    >
      <template v-slot:top>
        <div class="side-frame-success">
          <span class="side-frame-text">
            {{ $l('group_settlement_expense_item') || '结算单费用明细' }}
          </span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            @click="statementOptionalVisible = true"
            v-if="!disabled"
          >
            <i class="el-icon-plus" />
            {{ $l('INDEX.btn_add') || '新增' }}
          </b-button>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_delete') || '删除'"
            placement="top"
            v-if="!disabled && row.children"
          >
            <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <StatementOptional
      :shipmentExpenseCode="shipmentExpenseCode"
      :visible.sync="statementOptionalVisible"
      :title="
        $l('dialog_title_choose_shipment_payment_settlement') ||
          '选择发运记录付款结算单'
      "
      @confirm="onStatementOptionalConfirm"
    />

    <el-dialog
      append-to-body
      :title="$l('dialog_title_delete_item') || '请选择删除方式'"
      :visible.sync="deleteDialogVisible"
      width="30%"
    >
      <span>
        {{
          $l('dialog_content_delete') ||
            '删除填报记录：仅将记录从本次填报单中删除'
        }}
      </span>
      <br />
      <span>
        {{
          $l('dialog_content_delete_and_rejected') ||
            '删除并退回驳回：将记录从本次填报中删除，并退回结算记录进行修改'
        }}
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="delAndRejected()" type="warning" size="small">
          {{ $l('btn_delete_and_rejected') || '删除并退回驳回' }}
        </el-button>
        <el-button @click="del()" type="primary" size="small">
          {{ $l('btn_delete') || '删除填报记录' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import { add } from '@/libs/util.number.js'
import StatementOptional from '../statement-optional'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { StatementOptional },
  mixins: [EditLoading],
  props: {
    shipmentExpenseCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    tableData: { type: Array, default: () => [] },
  },
  data() {
    return {
      v_tableData: [],
      tableColumns: tableColumns(this),
      statementOptionalVisible: false,
      deleteDialogVisible: false,
      deleteRow: {},
    }
  },
  watch: {
    tableData: {
      handler(e) {
        this.v_tableData = e || []
      },
      immediate: true,
    },
  },
  methods: {
    async validate() {
      const data = this.getTableData()
      if (!data || !data.length) {
        this.$message({
          message: this.$l('tips_add_expense_item') || '请添加费用明细',
          type: 'warning',
        })
        return false
      }
      const result = await this.$refs.itemTable.validate(true)
      return !result
    },
    getTableData() {
      const { tableData } = this.$refs.itemTable.getTableData()
      return tableData
    },
    async onStatementOptionalConfirm(e) {
      if (!e || !e.length) return

      // 过滤已选结算单
      const tableData = this.getTableData()
      const data = e
        .filter(
          (i) =>
            tableData.findIndex(
              (j) => i.shipmentPayStatementCode === j.shipmentPayStatementCode
            ) < 0
        )
        .map((item) => {
          const {
            shipmentPayStatementCode,
            shipmentPayStatementNo: customsNo,
            currencyTotalAmount: currencyAmount,
            v_currencyTotalAmount: v_currencyAmount,
            remark: expenseRemark,
            listDoc,
            expenseType,
            children,
            custCode,
            custName,
            v_expenseType,
            payScmName,
            payerName,
            bankName,
            bankAccountName,
            bankAccountNo,
            v_bankAccountType,
            v_bankAccountKind,
            v_currencyUnit,
            depCode,
            orgDepFullName,
          } = item
          if (children && children.length > 0) {
            return {
              shipmentPayStatementCode,
              currencyAmount,
              custCode,
              v_currencyAmount,
              customsNo,
              expenseRemark,
              listDoc,
              expenseType,
              children,
            }
          } else {
            return {
              shipmentPayStatementCode,
              currencyAmount,
              v_currencyAmount,
              customsNo,
              custCode,
              custName,
              v_expenseType,
              payScmName,
              payerName,
              bankName,
              bankAccountName,
              bankAccountNo,
              v_bankAccountType,
              v_bankAccountKind,
              v_currencyUnit,
              expenseRemark,
              listDoc,
              expenseType,
              children,
              depCode,
              orgDepFullName,
            }
          }
        })

      const listDoc = data.reduce(
        (result, next) => result.concat(next.listDoc || []),
        []
      )
      this.$emit(
        'addDoc',
        listDoc.map((item) => {
          return { ...item, uploadByName: '', uploadTime: '' }
        })
      )

      const $itemTable = this.$refs.itemTable
      data.map(async (item) => {
        const { row } = await $itemTable.insertAt({ ...item }, -1)
        return row
      })
      this.subTotAmount()
      $itemTable.setAllTreeExpand(true)
    },
    async delRow(row) {
      this.deleteDialogVisible = true
      this.deleteRow = row
    },
    del() {
      this.$refs.itemTable.remove(this.deleteRow)
      this.subTotAmount()
      this.deleteDialogVisible = false
    },
    async delAndRejected() {
      const { shipmentPayStatementCode } = this.deleteRow
      if (!shipmentPayStatementCode) return
      // 先驳回在删除，避免删除了驳回失败
      this.loadingOpen()
      const res = await this.$api
        .shipmentPayStatementRejectReviewApi({
          shipmentPayStatementCode,
          shipmentExpenseCode: this.shipmentExpenseCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_reject_failed') || '驳回失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_rejected_successfully') || '驳回成功！',
        type: 'success',
      })
      this.del()
    },
    async subTotAmount() {
      const data = this.getTableData()
      const totAmount = data.reduce(
        (result, next) => add(result, next.currencyAmount),
        0
      )
      this.$emit('updateTotAmount', totAmount)
    },
  },
}
</script>
